import React, { useState, useEffect } from "react";
import { Table, Input, Button, Space, Popconfirm, message, Modal, Switch } from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import { API_DELETE_MAIN_LAUNDRY } from "api/main-laundry-management";
import EditLaundry from "views/admin/mainlaundryManagement/EditLaundry";
import ViewLaundry from "views/admin/mainlaundryManagement/ViewLaundry/ViewLaundry";
import { API_LIST_ROLE } from "api/role-management";
import { API_DELETE_ROLE } from "api/role-management";
import EditRole from "views/admin/roleManagement/EditRole";
import ViewRole from "views/admin/roleManagement/ViewRole/ViewRole";
import { API_LIST_CATAGORY } from "api/catagory-managemnt";
import { API_DELETE_CATAGORY } from "api/catagory-managemnt";
import EditCatagory from "views/admin/catagorymanagemnt/EditCatagory";
import ViewCatagory from "views/admin/catagorymanagemnt/ViewCatagory/ViewCatagory";
import { API_LIST_SERVICE } from "api/service-managemnt";
import ViewService from "views/admin/ServicesManagemnt/ViewService/ViewService";
import EditService from "views/admin/ServicesManagemnt/EditService";
import { API_DELETE_SERVICE } from "api/service-managemnt";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_DELETE_ITEM_SERVICE } from "api/item-services-managemnt";
import { API_LIST_ITEM_SERVICE } from "api/item-services-managemnt";
import EditItem from "views/admin/itemManagement/EditItem";
import ViewItem from "views/admin/itemManagement/ViewItem/ViewItem";
import { API_LIST_ITEM } from "api/item-management";
import { API_DELETE_ITEM } from "api/item-management";
import ViewItemService from "views/admin/itemServicesManagement/ViewItem/ViewItem";
import EditItemService from "views/admin/itemServicesManagement/EditItemService";
import moment from "moment";
import { API_ENABLE_DISABLE_ITEM_SERVICE } from "api/item-services-managemnt";
import { API_LIST_TAX } from "api/tax-api";
import { API_DELETE_TAX } from "api/tax-api";
import { API_ENABLE_DISABLE_TAX } from "api/tax-api";
const { Column } = Table;

const { TextArea } = Input;

const Taxtable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_TAX(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_item_services }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/tax/edit/${record._id}`, {
      state: { data: record },
    });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/tax/${record._id}`, {
      state: { data: record },
    });
  };

  const handleDelete = async (id) => {
    try {
      let q = await API_DELETE_TAX(id);
      message.success(q?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting store:", error);
      message.error("Failed to delete store");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };
  const handleSwitchChange = async (checked, record) => {
    try {
      const response = await API_ENABLE_DISABLE_TAX(record._id); // Assuming API_ENABLE_DISABLE_DRIVER accepts driver ID and status as parameters
      message.success(response?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error toggling driver status:", error);
      message.error("Failed to toggle driver status");
    }
  };
  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  return (
    <div>
      <div className=" mb-4 flex justify-between">
        <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        />

        <Link
          to={"/admin/tax/create-tax"}
          className="linear p-[4px 11px] flex w-full max-w-[12rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
        >
          + {t("Create Tax")}
        </Link>
      </div>
      <Table
        dataSource={data?.tax}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id} // Assuming each record has a unique id
        rowClassName={getRowClassName} // Apply alternating row colors
        scroll={{ x: true }}
      >

        <Column title={t("Name")} dataIndex="tax_title" key="tax_title" />
        <Column
          title={t("Created At")}
          dataIndex="created_at"
          key="created_at"
          render={(text, record) =>
            moment.unix(record.created_at).format("DD/MM/YYYY")
          }
        />
       <Column
          title={t("Status")}
          dataIndex="is_disable"
          key="is_disable"
          render={(text, record) => (
            <Switch
              checked={!record.is_disable}
              onChange={(checked) => handleSwitchChange(checked, record)}
            />
          )}
        />
        {/* <Column
          title={t("Service Description")}
          dataIndex="item_services"
          key="item_services "
        /> */}

        <Column
          title={t("Actions")}
          key="actions"
          render={(text, record) => (
            <div>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              ></Button>
              <Popconfirm
                title="Are you sure to delete this Item Service ?"
                onConfirm={() => handleDelete(record?._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="danger"
                  icon={<DeleteOutlined />}
                  style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                ></Button>{" "}
              </Popconfirm>
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
            </div>
          )}
        />
      </Table>

      {/* Edit Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("Edit Service")}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "65rem" }}
      >
        <EditItemService dataItem={selectedStore} />
      </Modal>

      {/* View Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("View Service")}
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "60rem" }}
      >
        <ViewItemService dataItem={selectedStore} />
      </Modal>
    </div>
  );
};

export default Taxtable;
